let mixins
// eslint-disable-next-line no-undef
if (APPSETTINGS.DataStore.store === 'ichabodcms') {
  mixins = {
    computed: {
      wrapperClass: function() {
        return `item-${this.item.id}`
      },
      wysiwgBody: function() {
        return this.item.body
      }
    }
  }
}
else {
  mixins = {
    computed: {
      wrapperClass: function() {
        return `node-${this.item.nid}`
      },
      wysiwgBody: function() {
        if (this.field === 'body') {
          return this.item.body
        }
        else {
          return this.item[this.field]
        }
      }
    }
  }
}
export default mixins
